import { Button, DocumentCheckbox, Header } from '@components/Generic'
import { observer } from 'mobx-react'
import { useContext, useEffect, useState } from 'react'
import { StoreContext } from '@store/Root.store'
import privacy_policy from '../assets/privacy_policy.pdf'
import videoid_terms from '../assets/videoid_terms.pdf'
import videoId_privacy_policy from '../assets/videoId_privacy_policy.pdf'
import { CheckedEvent } from '@/types/generic'
import { cx } from '@/utils/cx'

export const GeneralConditionsBeforeBankSelectionPage = observer(() => {
  const store = useContext(StoreContext)
  const { isMobile } = store.AppState
  const { generalConditionsPage: trans } = store.TranslationsState.translations

  // Checkboxes state
  const [terms, setTerms] = useState(false)
  const [policy, setPolicy] = useState(false)
  const [biometrics, setBiometrics] = useState(false)
  const [tickAll, setTickAll] = useState(false)

  const handleProceed = async () => {
    if (!(terms && policy)) return

    store.ScenarioState.nextPage()
  }

  const handleTerms = ({ checked: value }: CheckedEvent) => {
    setTerms(value)
  }

  const handlePolicy = ({ checked: value }: CheckedEvent) => {
    setPolicy(value)
  }

  const handleBiometrics = ({ checked: value }: CheckedEvent) => {
    setBiometrics(value)
  }

  const handleTickAll = () => {
    setTickAll(!tickAll)
  }

  useEffect(() => {
    setTerms(tickAll)
    setPolicy(tickAll)
    setBiometrics(tickAll)
  }, [tickAll])

  return (
    <div className={cx('page-container', 'mobile-m-0', 'mobile-p-14-40')}>
      <>
        <Header>{trans.header}</Header>

        <p className="generic__intro-paragraph">
          {
            'Welcome to the Signicat Identity Verification Process. Signicat, with our subsidiary ElectronicID, is a EU certified '
          }
          <a
            className="generic__link"
            href="https://eidas.ec.europa.eu/efda/tl-browser/#/screen/tl/ES/42"
            target="_blank"
            rel="noreferrer"
          >
            trusted service provider
          </a>
        </p>

        <DocumentCheckbox
          title="Terms and Conditions of use"
          isRequired
          showAsterisk
          inputName="terms-checkbox"
          description="I accept the terms and conditions of the video-identification process"
          externalUrl={videoid_terms}
          handleDecision={handleTerms}
          value={terms}
          goToDocumentLabel={trans.goToDocument}
        />

        <DocumentCheckbox
          title="Privacy Policy"
          isRequired
          showAsterisk
          inputName="privacy-checkbox"
          description="I have read the Privacy Policy and I consent to the processing and storage of my biometric data and the complete recording of the video. Otherwise, you have other alternatives identified in the Terms and Conditions"
          externalUrl={videoId_privacy_policy}
          handleDecision={handlePolicy}
          value={policy}
          goToDocumentLabel={trans.goToDocument}
        />

        <DocumentCheckbox
          title="Collecting data during VideoID"
          inputName="biometrics-checkbox"
          description="I Consent to Signicat SLU to use my data, collected in the VideoID process, to improve their software to recognize and prevent fraud."
          externalUrl={privacy_policy}
          handleDecision={handleBiometrics}
          value={biometrics}
          goToDocumentLabel={trans.goToDocument}
        />

        <div className="layout__tick-all-style">
          <div className="generic__required-footer">{trans.required}</div>
          <label className="label-checkbox" tabIndex={0}>
            <input
              id="tick-all"
              type="checkbox"
              name="tick-all"
              checked={tickAll}
              onChange={handleTickAll}
              tabIndex={-1}
            />

            {trans.tickAll}
          </label>
        </div>

        <div className="layout__content-container-bottom-fixed">
          {!isMobile ? <div className="layout__content-container-bottom-left" /> : <div />}

          <Button
            onClick={handleProceed}
            disabled={!(terms && policy)}
            className="button--w164"
            id="page-submit"
          >
            <>
              <span className="generic__button-text">{trans.proceed}</span>
            </>
          </Button>
        </div>
      </>
    </div>
  )
})
